import Indicator from '../Indicator';
import LineMarker from '../markers/LineMarker';
import BandMarker from '../markers/BandMarker';

/** Williams %R indicator */
export default class WilliamsIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {object[]} bands - Indicator bands
	 */
	_getDefaultParams() {
		return {
			id: 'williamspctr',
			name: 'Williams %R',
			description:
				'Williams %R uses a similar calculation to the Stochastic Oscillator and provides information on the price momentum of a security. It is also used to identify overbought and oversold levels.',
			inputs: [{ name: 'period', value: 14 }],
			bands: [
				{
					labelTranslationKey: 'band.overbought',
					valHigh: 0,
					valLow: -20
				},
				{
					labelTranslationKey: 'band.oversold',
					valHigh: -80,
					valLow: -100
				}
			],
			componentSeries: [
				{ id: 'williamspctr' }
			]
		};
	}

	/** @return {number} -100 */
	getRangeMin() {
		return -100;
	}

	/** @return {number} 0 */
	getRangeMax() {
		return 0;
	}

	/**
	 * @return {object}
	 * @property {LineMarker} line
	 * @property {BandMarker} overbought
	 * @property {BandMarker} oversold
	 */
	_getMarkers() {
		return {
			line: new LineMarker(),
			overbought: new BandMarker(this.params.bands[0], this.panel),
			oversold: new BandMarker(this.params.bands[1], this.panel)
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this.markers.overbought.render(this.panel, this.params.style.overbought);
		this.markers.oversold.render(this.panel, this.params.style.oversold);
		this._renderLineMarker({
			data: data.williamspctr,
			sessionType
		});
	}
}
